import {
  LOAD_PRODUCTS,
  LOAD_SUBGROUPS,
  LOAD_VIRTUAL_PACKS,
  PRODUCTS_LOADED,
  RESET_PRODUCTS,
  RESET_SUBGROUPS,
  SUBGROUPS_LOADED,
  SUBGROUPS_SYNC_FAILED,
  SYNC_FAILED,
  VIRTUAL_PACKS_LOADED,
  VIRTUAL_PACKS_SYNC_FAILED,
  RESET_VIRTUAL_PACKS,
} from './actionTypes';
import type { IProductsState, IProductSubgroup } from './types';

const countSubGroupsProducts = (
  subGroups: IProductSubgroup[],
  products: IProductsState['products'],
): IProductSubgroup[] => {
  if (!products || products.length === 0) return subGroups;

  const productsCountBySubGroup = products.reduce((res, product) => {
    res[product.subGroupDescription || ''] =
      product.subGroupDescription && product.subGroupDescription in res
        ? res[product.subGroupDescription] + 1
        : 1;

    return res;
  }, {});

  return subGroups.map((subGroup) => ({
    ...subGroup,
    productsCount: productsCountBySubGroup[subGroup.subGroupDescription] || 0,
  }));
};

export const initialState: IProductsState = {
  error: null,
  loadedProductType: '',
  loadedParams: {},
  products: [],
  loading: false,
  subGroups: {
    error: null,
    loaded: false,
    data: [],
    loading: false,
  },
  virtualPacks: {
    error: null,
    loaded: false,
    data: [],
    loading: false,
  },
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_PRODUCTS:
      return { ...state, error: null, loading: true, loadedProductType: '', loadedParams: {} };
    case PRODUCTS_LOADED:
      return {
        ...state,
        error: null,
        products: action.payload.data,
        subGroups: {
          ...state.subGroups,
          data: countSubGroupsProducts(state.subGroups.data, action.payload.data),
        },
        loading: false,
        loadedProductType: action.payload.productType,
        loadedParams: action.payload.params,
      };

    case RESET_PRODUCTS:
      return { ...initialState, subGroups: state.subGroups };
    case SYNC_FAILED:
      return { ...state, loading: false, error: action.payload };
    case LOAD_SUBGROUPS:
      return { ...state, subGroups: { ...state.subGroups, error: null, loading: true } };
    case SUBGROUPS_LOADED:
      return {
        ...state,
        subGroups: {
          error: null,
          data: countSubGroupsProducts(action.payload, state.products),
          loading: false,
          loaded: true,
        },
      };

    case RESET_SUBGROUPS:
      return { ...state, subGroups: initialState.subGroups };
    case SUBGROUPS_SYNC_FAILED:
      return {
        ...state,
        subGroups: {
          ...state.subGroups,
          loading: false,
          error: action.payload,
        },
      };
    case LOAD_VIRTUAL_PACKS:
      return {
        ...state,
        virtualPacks: {
          ...state.virtualPacks,
          error: null,
          loading: true,
        },
      };
    case VIRTUAL_PACKS_LOADED:
      return {
        ...state,
        virtualPacks: {
          error: null,
          data: action.payload,
          loading: false,
          loaded: true,
        },
      };
    case VIRTUAL_PACKS_SYNC_FAILED:
      return {
        ...state,
        virtualPacks: {
          ...state.virtualPacks,
          loading: false,
          error: action.payload,
        },
      };
    case RESET_VIRTUAL_PACKS:
      return {
        ...state,
        virtualPacks: initialState.virtualPacks,
      };
    default:
      return state;
  }
};
